function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { QueryReportHeaderReact } from 'common/query-builder/query-report-header';
import { EntityType } from 'common/report/util/saved-entities/types';
import { SearchDisplayContext } from 'common/report/util/search/types';
import { HeaderAction, QueryReportHeaderParams } from 'common/query-builder/query-report-header/types';
import { buildQueryReportHeaderParams } from 'common/report/util/saved-entities';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { useDeleteExperiment } from 'apps/experiments/src/components/hooks/delete-experiment';
import { useDuplicateExperiment } from 'apps/experiments/src/components/hooks/duplicate-experiment';
import { useUpdateExperiment } from 'apps/experiments/src/components/hooks/update-experiment';
import styles from './index.module.styl';
export function ExperimentPageHeader() {
  const {
    projectId,
    workspaceId,
    userId,
    experimentId,
    experimentEntity
  } = useExperimentPageContext();
  const deleteExperiment = useDeleteExperiment({
    isListPage: false
  });
  const duplicateExperiment = useDuplicateExperiment({
    isListPage: false
  });
  const updateExperiment = useUpdateExperiment();
  const queryReportHeaderParams: QueryReportHeaderParams = React.useMemo(() => {
    return _objectSpread(_objectSpread({}, buildQueryReportHeaderParams({
      projectId,
      entityType: EntityType.Experiment,
      entity: experimentEntity!,
      invalidEntity: !experimentId,
      displayContext: SearchDisplayContext.Experiment
    })), {}, {
      // TODO - after content sidebar is implemented
      // headerActionItemsEl: ContentFavoriteButton({
      //   isSelected: currentExperiment?.is_favorited,
      //   i18n,
      //   tooltipTranslationKeys: {
      //     favorite: `experiments.actions.favorite.label` as TranslationKey,
      //     unfavorite: `experiments.actions.unfavorite.label` as TranslationKey,
      //   },
      //   onClick: () => {
      //     // TODO - favorite/unfavorite experiment
      //   },
      // }),
      displayContext: SearchDisplayContext.Experiment,
      entityType: EntityType.Experiment,
      trackName: "[Experiment]",
      overflowControlItems: [
        // TODO - after content sidebar is implemented
        // {
        //   items: [
        //     ...(currentExperiment?.can_pin
        //       ? [
        //           {
        //             name: CustomHeaderAction.PinExperiment,
        //             label: currentExperiment?.pinned_date
        //               ? i18n.t(`experiments.actions.unpin.label`)
        //               : i18n.t(`experiments.actions.pin.label`),
        //             icon: currentExperiment?.pinned_date ? `filled-pin` : `pin`,
        //             highlightIcon: Boolean(currentExperiment?.pinned_date),
        //           },
        //         ]
        //       : []),
        //   ],
        // },
      ],
      // TODO - after content sidebar is implemented
      // controlItems: [{slot: `favoriteButton`}],
      hasUnsavedChanges: false,
      invalidMessage: "",
      projectId,
      workspaceId,
      userId
    });
  }, [experimentEntity]);
  const handleHeaderActionClick = React.useCallback((ev: CustomEvent) => {
    const actionName = ev.detail.name || ev.detail.value;
    switch (actionName) {
      case HeaderAction.Delete:
        deleteExperiment.mutate({
          id: experimentId!
        });
        break;
      case HeaderAction.Duplicate:
        duplicateExperiment.mutate({
          id: experimentId!
        });
        break;
    }
  }, [deleteExperiment, duplicateExperiment, experimentId]);
  const handleSave = React.useCallback((ev: CustomEvent<{
    name: string;
  }>) => {
    const newName = ev.detail.name;
    updateExperiment({
      id: experimentId!,
      name: newName
    });
  }, [experimentId, updateExperiment]);
  return <div className={styles.container} data-sentry-component="ExperimentPageHeader" data-sentry-source-file="index.tsx">
      <QueryReportHeaderReact {...queryReportHeaderParams} onActionclick={handleHeaderActionClick} onSave={handleSave} data-sentry-element="QueryReportHeaderReact" data-sentry-source-file="index.tsx" />
    </div>;
}